import React, { useState, useEffect } from "react";
import { 
  Dialog, DialogTitle, DialogContent, 
  DialogActions, Button, List, ListItem, ListItemText, 
  Typography, Divider, IconButton, Chip 
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PrintIcon from '@mui/icons-material/Print';
import { collection, query, where, onSnapshot, orderBy, doc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firebase";

function BildirimKutusu({ sube, forceOpen, onClose }) {
  const [bildirimler, setBildirimler] = useState([]);
  // forceOpen true ise liste direkt açık başlar
  const [openList, setOpenList] = useState(forceOpen || false);
  const [selectedBildirim, setSelectedBildirim] = useState(null);

  // Kapatma Fonksiyonu
  const handleCloseList = () => {
    setOpenList(false);
    if (onClose) onClose(); // Dashboard'a kapandığını bildir
  };

  useEffect(() => {
    if (!sube) return;

    const q = query(
      collection(db, "bildirimler"),
      where("hedefSube", "in", [sube, "hepsi"]),
      orderBy("tarih", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setBildirimler(data);
    });

    return () => unsubscribe();
  }, [sube]);

  const isRead = (bildirim) => {
    return bildirim.okunanSubeler && bildirim.okunanSubeler.includes(sube);
  };

  const handleOkunduIsaretle = async (bildirim) => {
    try {
      const bildirimRef = doc(db, "bildirimler", bildirim.id);
      await updateDoc(bildirimRef, {
        okunanSubeler: arrayUnion(sube)
      });
      setSelectedBildirim(null); 
    } catch (error) {
      console.error("Hata:", error);
    }
  };
  
  const handlePrint = () => {
    const content = document.getElementById('printable-notification').innerHTML;
    const win = window.open('', '', 'height=700,width=700');
    win.document.write('<html><head><title>Bildirim Yazdır</title></head><body>');
    win.document.write(content);
    win.document.write('</body></html>');
    win.document.close();
    win.print();
  };

  return (
    <>
      {/* FAB BUTONU SİLİNDİ - Sadece Dialoglar Kaldı */}

      {/* LİSTE PENCERESİ */}
      <Dialog open={openList} onClose={handleCloseList} fullWidth maxWidth="sm">
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Bildirimler
          <IconButton onClick={handleCloseList}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <List>
            {bildirimler.length === 0 ? (
              <Typography sx={{ p: 3, textAlign: 'center', color: 'gray' }}>Bildirim yok.</Typography>
            ) : (
              bildirimler.map((item) => {
                const read = isRead(item);
                return (
                  <React.Fragment key={item.id}>
                    <ListItem button onClick={() => setSelectedBildirim(item)} sx={{ bgcolor: read ? 'white' : '#e3f2fd' }}>
                      <ListItemText 
                        primary={<Typography fontWeight={read ? 'normal' : 'bold'}>{item.baslik}</Typography>}
                        secondary={item.tarih?.toDate().toLocaleString('tr-TR')}
                      />
                      {!read && <Chip label="YENİ" color="error" size="small" />}
                      {read && <CheckCircleIcon color="success" />}
                    </ListItem>
                    <Divider />
                  </React.Fragment>
                );
              })
            )}
          </List>
        </DialogContent>
      </Dialog>

      {/* DETAY PENCERESİ */}
      <Dialog open={!!selectedBildirim} onClose={() => setSelectedBildirim(null)} fullWidth maxWidth="md">
        <DialogTitle sx={{ bgcolor: '#1e3a8a', color: 'white', display: 'flex', justifyContent: 'space-between' }}>
          Bildirim Detayı
          <IconButton onClick={() => setSelectedBildirim(null)} sx={{ color: 'white' }}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <div id="printable-notification" style={{ padding: '20px' }}>
             {selectedBildirim && (
               <>
                 <Typography variant="h5" fontWeight="bold" gutterBottom color="#1e3a8a">{selectedBildirim.baslik}</Typography>
                 <Typography variant="caption" display="block" gutterBottom>Tarih: {selectedBildirim.tarih?.toDate().toLocaleString('tr-TR')}</Typography>
                 <Divider sx={{ my: 2 }} />
                 <Typography variant="body1" style={{ whiteSpace: 'pre-wrap', fontSize: '1.1rem' }}>{selectedBildirim.mesaj}</Typography>
               </>
             )}
          </div>
        </DialogContent>
        <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
          <Button startIcon={<PrintIcon />} onClick={handlePrint} variant="outlined">Yazdır</Button>
          
          {selectedBildirim && !isRead(selectedBildirim) ? (
            <Button variant="contained" color="success" startIcon={<CheckCircleIcon />} onClick={() => handleOkunduIsaretle(selectedBildirim)}>
              OKUDUM, ANLAŞILDI
            </Button>
          ) : (
            <Button disabled variant="contained">Bu bildirim okundu</Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BildirimKutusu;